import axios from 'axios'

const state = {
  poolEntryList: [],
  poolKOEntryList: [],
  poolEntryLoaded: true,
  poolKOEntryLoaded: true,
  uPoolEntryList: [],
  uPoolKOEntryList: [],
  uPoolEntryLoaded: true,
  uPoolKOEntryLoaded: true,
}

const getters = {
  poolEntryList: state => state.poolEntryList,
  poolKOEntryList: state => state.poolKOEntryList,
  poolEntryLoaded: state => state.poolEntryLoaded,
  poolKOEntryLoaded: state => state.poolKOEntryLoaded,
  uPoolEntryList: state => state.uPoolEntryList,
  uPoolKOEntryList: state => state.uPoolKOEntryList,
  uPoolEntryLoaded: state => state.uPoolEntryLoaded,
  uPoolKOEntryLoaded: state => state.uPoolKOEntryLoaded,
}

const actions = {
  getPoolEntryList ({ commit }, poolId) {
    commit('POOLENTRY_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get("/api/userPoolEntry/" + poolId, { headers: header })
    .then(response => {
      commit('POOLENTRY', response.data)
      commit('POOLENTRY_LOADED', true)
    })
  },
  getPoolKOEntryList ({ commit }, poolId) {
    commit('POOLKOENTRY_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get("/api/userPoolKOEntry/" + poolId, { headers: header })
    .then(response => {
      commit('POOLKOENTRY', response.data)
      commit('POOLKOENTRY_LOADED', true)
    })
  },
  getUserPoolEntryList ({ commit }, data) {
    commit('UPOOLENTRY_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get("/api/userPoolEntry/" + data.poolId + "/" + data.userId, { headers: header })
    .then(response => {
      commit('UPOOLENTRY', response.data)
      commit('UPOOLENTRY_LOADED', true)
    })
  },
  getUserPoolKOEntryList ({ commit }, data) {
    commit('UPOOLKOENTRY_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get("/api/userPoolKOEntry/" + data.poolId + "/" + data.userId, { headers: header })
    .then(response => {
      commit('UPOOLKOENTRY', response.data)
      commit('UPOOLKOENTRY_LOADED', true)
    })
  },
}

const mutations = {
  POOLENTRY(state, payload) {
    state.poolEntryList = payload
  },
  POOLENTRY_LOADED(state, payload) {
    state.poolEntryLoaded = payload
  },
  POOLKOENTRY(state, payload) {
    state.poolKOEntryList = payload
  },
  POOLKOENTRY_LOADED(state, payload) {
    state.poolKOEntryLoaded = payload
  },
  UPOOLENTRY(state, payload) {
    state.uPoolEntryList = payload
  },
  UPOOLENTRY_LOADED(state, payload) {
    state.uPoolEntryLoaded = payload
  },
  UPOOLKOENTRY(state, payload) {
    state.uPoolKOEntryList = payload
    state.uPoolKOEntryList.sort((a, b) => {
      return b.koLevel- a.koLevel
    })
  },
  UPOOLKOENTRY_LOADED(state, payload) {
    state.uPoolKOEntryLoaded = payload
  },
}

export default {
  state, getters, actions, mutations
}
